
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import { CreateJobDialog } from "./CreateJobDialog";
import { useEvaluationUsage } from "@/hooks/useEvaluationUsage";
import { EvaluationLimitDialog } from "@/components/dialogs/EvaluationLimitDialog";

export function CreateJobButton() {
  const [showDialog, setShowDialog] = useState(false);
  const [showEvaluationLimitDialog, setShowEvaluationLimitDialog] = useState(false);
  const { usage: evaluationUsage } = useEvaluationUsage();
  
  const canCreateEvaluations = evaluationUsage?.can_create_tests ?? true;

  const handleClick = () => {
    if (!canCreateEvaluations) {
      setShowEvaluationLimitDialog(true);
    } else {
      setShowDialog(true);
    }
  };

  return (
    <>
      <Button 
        onClick={handleClick} 
        size="sm"
        disabled={!canCreateEvaluations}
        className="bg-secondary text-secondary-foreground hover:bg-secondary/90 disabled:opacity-50"
      >
        <PlusCircle className="mr-2 h-4 w-4" />
        Create New Test
      </Button>

      <CreateJobDialog
        open={showDialog}
        onOpenChange={setShowDialog}
      />

      <EvaluationLimitDialog
        open={showEvaluationLimitDialog}
        onOpenChange={setShowEvaluationLimitDialog}
      />
    </>
  );
}
